import { render, staticRenderFns } from "./CoAcceptReject.vue?vue&type=template&id=1db1294c&scoped=true&"
import script from "./CoAcceptReject.vue?vue&type=script&lang=ts&"
export * from "./CoAcceptReject.vue?vue&type=script&lang=ts&"
import style0 from "./CoAcceptReject.vue?vue&type=style&index=0&id=1db1294c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db1294c",
  null
  
)

export default component.exports